import React from 'react';
import useTitleEditor from '../hooks/useTitleEditor';

/**
 * EditableTitle - Click-to-edit campaign name
 * Uses useTitleEditor hook for cursor positioning and edit state
 */
const EditableTitle = ({ 
  name, 
  onRename,
  classPrefix = 'campaign-header',
}) => {
  const {
    isEditing,
    editValue,
    inputRef,
    textRef,
    handleClick,
    handleSave,
    handleKeyDown,
    handleChange,
    canEdit,
  } = useTitleEditor(name, onRename);

  if (isEditing) {
    return (
      <input
        ref={inputRef}
        type="text"
        className={`${classPrefix}__title-input`}
        value={editValue}
        onChange={handleChange}
        onBlur={handleSave}
        onKeyDown={handleKeyDown}
        onMouseDown={(e) => e.stopPropagation()}
        onPointerDown={(e) => e.stopPropagation()}
      />
    );
  }

  return (
    <h2 
      ref={textRef}
      className={`${classPrefix}__title ${canEdit ? `${classPrefix}__title--editable` : ''}`}
      onClick={handleClick}
      title={canEdit ? "Click to rename" : undefined}
    >
      {name}
    </h2>
  );
};

export default EditableTitle;
